import { render } from "./accessoire.vue?vue&type=template&id=122d7a10&scoped=true"
import script from "./accessoire.vue?vue&type=script&lang=js"
export * from "./accessoire.vue?vue&type=script&lang=js"

import "./accessoire.vue?vue&type=style&index=0&id=122d7a10&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122d7a10"]])

export default __exports__